<template>
	<div class="pdf-download">
		<a v-if="enabled" tabindex="0" role="button" v-tooltip="{ content: content.downloadPDF }" :href="downloadablePDF" class="pdf-btn btn"
			data-tour-item="pdf"  @click="closeHamburgerMenu">
			<svg role="img" width="20" height="24" xmlns="http://www.w3.org/2000/svg" aria-labelledby="downloadPdf">
				<path
					d="M12.02 0c.82 0 1.24.17 1.82.75l5.4 5.41c.59.58.76 1 .76 1.82V22.4c0 1.15-.45 1.6-1.6 1.6H1.6C.45 24 0 23.55 0 22.4V1.6C0 .45.45 0 1.6 0zm6.58 17.02H1.4v5.16c0 .3.12.42.42.42h16.36c.3 0 .42-.12.42-.42v-5.16zM9.6 11c-.54 0-1.05.03-1.44.1v4.63c.26.04.65.07 1.2.07.93 0 1.69-.2 2.18-.6.46-.4.79-1.02.79-1.92 0-.83-.31-1.41-.8-1.78-.46-.34-1.04-.5-1.93-.5zm-4.07 0c-.65 0-1.11.04-1.44.1v4.65h1.06v-1.69c.1.02.22.03.36.03.63 0 1.17-.16 1.53-.5.28-.27.44-.66.44-1.12 0-.46-.2-.85-.5-1.1-.32-.24-.79-.37-1.45-.37zm10.38.03h-2.88v4.72h1.07v-1.9h1.7V13h-1.7V11.9h1.8v-.88zm-6.2.79c.92 0 1.49.52 1.48 1.5 0 1.12-.63 1.65-1.6 1.65-.13 0-.27 0-.36-.02v-3.09c.09-.02.24-.04.48-.04zm-4.12-.02c.53 0 .83.26.83.7 0 .48-.35.77-.92.77-.15 0-.26-.01-.35-.03v-1.4c.07-.01.22-.04.44-.04zm6.86-10.4H1.82c-.3 0-.42.12-.42.42v7.96h17.2V7.55c0-.15-.06-.21-.2-.21h-4.14c-1.15 0-1.6-.45-1.6-1.6V1.61c0-.15-.06-.21-.21-.21z"
					fill="#545454" fill-rule="nonzero" />
			</svg>
			<!-- <img :alt="content.downloadPDF" src="/images/icon-pdf.svg"/> -->
		    <span>{{ content.downloadPDF }}</span>
		</a>
		
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import featureMixin from "@/mixins/featureMixin";

export default {
	name: "PdfDownloadButtonV2",
	mixins: [featureMixin],
	data() {
		return {
			featurePath: 'pdfDownload'
		}
	},
	computed: {
		...mapGetters(["content"]),
		...mapGetters('config', ['features']),
		...mapGetters('landingPage', ['downloadablePDF']),
	},
	methods: {
		closeHamburgerMenu() {
			this.$parent.isHidden = !this.$parent.isHidden
		}
	}
}
</script>

<style lang="scss" scoped>
.pdf-download {
	display: inline-flex;
	align-items: center;

	a {
		border: none;
		background: none;
		text-decoration: none;
		
	}

}
</style>
